<template>
	<div style="height: 600px; ">
		<Row :gutter="10" style="margin-bottom: 20px">
			<Form :label-width="80">
				<FormItem label="搜索类型">
					<Input v-model="content" placeholder="搜索内容" style="width: 200px;"></Input>
					<Select v-model="type" placeholder="信息类型" style="width: 200px;padding-left: 20px;">
						<Option value="1">系统通知</Option>
						<Option value="2">新客户通知</Option>
						<Option value="3">点评通知</Option>
						<Option value="4">上门扫码通知</Option>
						<Option value="5">重复申请通知</Option>
						<Option value="6">备忘通知</Option>
					</Select>
					<Select v-model="status" placeholder="状态" style="width: 200px;padding-left: 20px;">
						<Option value="1">已读</Option>
						<Option value="0">未读</Option>
					</Select>
				</FormItem>
				<FormItem label="时间">
					<RadioGroup v-model="timePeriod">
						<Radio label="0" border><span>不限</span></Radio>
						<Radio label="1" border><span>今日</span></Radio>
						<Radio label="2" border><span>昨天</span></Radio>
						<Radio label="3" border><span>本周</span></Radio>
						<Radio label="4" border><span>上周</span></Radio>
						<Radio label="5" border><span>本月</span></Radio>
						<Radio label="6" border><span>上月</span></Radio>
						<Radio label="7" border><span>自定义</span></Radio>
						<DatePicker v-if="timePeriod == '7' " :value="timePeriodDate" @on-change="changeTimePeriod"
							type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
					</RadioGroup>
				</FormItem>
				<FormItem label="操作">
					<Button style="margin-left: 0px;" type="primary" v-on:click="mySearch()">搜索</Button>
					<Button style="margin-left: 20px;" type="primary" v-on:click="initSearch()">重置</Button>
				</FormItem>
			</Form>
		</Row>
		<div style=" overflow-x: hidden">
			<Table height="400" border :columns="columns" :data="msgListData">
				<template slot-scope="{ row }" slot="read_status">
					<span v-if="row.is_read == 0" style="cursor: pointer;color: #277dd3;"
						@click="signToRead(row)">【设为已读】</span>
					<span v-if="row.is_read == 1">已读</span>
				</template>
				<template slot-scope="{ row }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" 
						v-if="row.notice_client_id != '' && row.notice_client_id != 0 && row.notice_client_id != null" @click='goToClient(row)' >去查看</Button>
				</template>
			</Table>
		</div>
		<div class="pager1">
			<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
		</div>
	</div>
</template>

<script>
	import {
		getAllMsg
	} from "../../api/user";
	import {
		signNoticeToRead
	} from '../../api/notice.js'
	import {
		mapGetters,
		mapActions
	} from "vuex";
	export default {
		data() {
			return {
				columns: [{
						title: "类型",
						key: "type",
						align: 'center'
					},
					{
						title: "内容",
						key: "notice_msg",
						align: 'center'
					},
					{
						title: "通知时间",
						key: "msg_time",
						align: 'center'
					},
					{
						title: "状态",
						slot: "read_status",
						align: 'center'
					},
					{
						title: "操作",
						slot: "action",
						align: 'center'
					},
				],
				content: '',
				status: '',
				type: '',
				page: 1,
				pageSize: 10,
				pageSizeOpts: [10, 50, 100, 200, 500],
				count: 0,
				timePeriod: '0',
				timePeriodDate: '',
				msgListData: [],
				order_type: 'desc'
			};
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.getList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			mySearch() {
				this.getList();
			},
			initSearch() {
				this.content = '';
				this.page = 1;
				this.status = '';
				this.type = '';
				this.getList();
			},
			goToClient(row){
				let that = this;
				that.signToRead(row);
				this.$nextTick(function() {
					this.$router.push({
						name: 'newEditClue',
						params: {
							id: row.notice_client_id,
							name: row.client_name
						},
					})
				})
			},
			async getList() {
				let that = this;
				let data = {}
				data.token = this.token;
				data.content = that.content;
				data.type = that.type;
				data.status = that.status;
				data.timePeriod = that.timePeriod;
				data.timePeriodDate = that.timePeriodDate;
				let res = await getAllMsg(that, data);
				that.msgListData = res.data.msgList;
			},
			changeTimePeriod(e) {
				this.timePeriodDate = e;
				console.log(this.timePeriodDate)
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			signToRead(selectData) {
				let that = this;
				var selectNoticeInfo = []
				selectNoticeInfo.push(selectData)
				let data = {
					token: this.token,
					noticeInfo: selectNoticeInfo
				}
				if (selectNoticeInfo.length) {
					signNoticeToRead(data).then(function(res) {
						if (res.data.code == 1) {
							that.getList();
							that.$emit('reloadData');
							that.$Message.success('标记成功');
						} else {
							that.$Message.warning('标记失败');
						}
					});
				} else {
					that.$Message.warning('请先选择');
				}
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
		},
	};
</script>

<style lang="less" scoped>
	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #aaaa00;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>
